import React from "react";
import {IntlProvider} from "react-intl";
import {getCurrentTranslation} from "../utils/translations";
import PropTypes from "prop-types";
import BasketPage from "./Basket/basket";

const Basket = ({config}) => {

    return (
        <IntlProvider messages={getCurrentTranslation(config.locale)} locale={config.locale} defaultLocale="cs">
            <BasketPage config={config} />
        </IntlProvider>
    );

}

Basket.propTypes = {
    config: PropTypes.object.isRequired
};

Basket.defaultProps = {}

export default Basket;
